// extracted by mini-css-extract-plugin
export default {"type2":"AlertCustom_type2__zSoI-","app":"AlertCustom_app__vA3GF","hr":"AlertCustom_hr__Xob-Z"};